import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SccDicomDataComponent } from './scc-dicom-data.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    SccDicomDataComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class SccDicomDataModule { }
